export const getContact = (state) => state.contact

export const getFirstName = (state) => getContact(state).firstName || ''

export const getLastName = (state) => getContact(state).lastName || ''

export const getEmail = (state) => getContact(state).email || ''

export const getPhone = (state) => getContact(state).phone || ''

export const getSubject = (state) => getContact(state).subject || ''

export const getMessage = (state) => getContact(state).message || ''

export const getMessageSent = (state) => getContact(state).messageSent

export const getError = (state) => getContact(state).error


/** WEBPACK FOOTER **
 ** ./src/selectors/contact.selectors.js
 **/